var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tabs-header flex items-center justify-between py-10 sm-md:flex-col sm-md:py-5"
  }, [_c('h3', {
    staticClass: "sm-md:text-center sm-md:mb-5"
  }, [_vm._v(_vm._s(_vm.sectionHeader))]), _vm._v(" "), _c('ul', {
    staticClass: "flex items-center"
  }, _vm._l(_vm.tabs, function (tab, index) {
    return _c('li', {
      key: tab.title,
      staticClass: "tab pb-5 mr-5",
      class: _vm.selectedIndex === index ? '' : 'black-opacity',
      on: {
        "click": function ($event) {
          return _vm.selectTab(index);
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tab.title) + "\n\t\t\t")]);
  }), 0)]), _vm._v(" "), _vm._t("default")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };